(function() {
    'use strict';

    angular.module('app.contratos', []);
})();
